<template>
    <CRow>
        <CCol>
            <CCard class="store-card">
                <CCardHeader>
                    <strong>Создание типа бизнеса</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            v-model="entity.title"
                            label="Название"
                            placeholder="Введите название сервиса"
                        />
                        <CInput
                            v-model="entity.code"
                            label="Код"
                            placeholder="Введите код сервиса"
                        />
                        <CInput
                            v-model="entity.color"
                            label="Цвет"
                            placeholder="Введите цвет сервиса"
                        />
                        <CInput
                            v-model="entity.gradient"
                            label="Градиент"
                            placeholder="Введите градиент сервиса"
                        />
                        <CInput
                            v-model="entity.icon"
                            label="Иконка (Пример: cil-basket, ресурс:  https://iconify.design/icon-sets/cil/)"
                            placeholder="Введите код иконки"
                        />
                        <CInputFile
                            ref="picture"
                            label="Картинка сервиса в приложении"
                            horizontal
                            @change="selectPicture"
                        />
                        <CInputFile
                            ref="largePicture"
                            label="Картинка сервиса на сайте"
                            horizontal
                            @change="selectLargePicture"
                        />
                        <CCard class="p-3">
                            <CRow>
                                <CCol style="display: flex; align-items: center;">
                                    <span>Данные для аналитики</span>
                                    <CSwitch
                                        class="ml-3"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="entity.analytics_data"
                                    />
                                </CCol>
                            </CRow>
                            <CRow v-show="entity.analytics_data">
                                <CCol>
                                    <div>
                                        <CRow>
                                            <CCol style="display: flex; justify-content: space-between; align-items: center;">
                                                <span><b>Значения</b></span>
                                                <CButton color="primary" @click="addAnalyticsValue">
                                                    Добавить
                                                </CButton>
                                            </CCol>
                                        </CRow>
                                        <template v-for="(item, index) in entity.analytics_data_values">
                                            <CRow :key="`analytics_data_value-${index}`">
                                                <CCol>
                                                    <CInput
                                                        v-model="item.title"
                                                        placeholder="Введите значение"
                                                        @input="setAnalyticsValue(index, $event)"
                                                    />
                                                </CCol>
                                                <CCol>
                                                    <CButton color="danger" @click="removeAnalyticsValue(index)">
                                                        Удалить
                                                    </CButton>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCard>
                        <CRow style="margin-top: 6px">
                            <span class="ml-3">Активно (десктоп)</span>
                            <CSwitch
                                class="ml-3"
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="entity.enabled"
                            />
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="$router.push('/settings/entities')"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'EntityTypeCreate',

        data() {
            return {
                entity: {
                    title: '',
                    code: '',
                    color: '',
                    gradient: '',
                    picture: '',
                    large_picture: '',
                    icon: '',
                    analytics_data: false,
                    analytics_data_values: [],
                    enabled: true,
                },
                selectedPicture: null,
                selectedLargePicture: null,
            };
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectLargePicture(FileList) {
                this.selectedLargePicture = FileList[0];
            },

            addAnalyticsValue() {
                let maxId = 0;

                if(!this.entity.analytics_data_values) {
                    this.entity.analytics_data_values = [];
                }
                for(const item of this.entity.analytics_data_values) {
                    if(item.id > maxId) {
                        maxId = item.id;
                    }
                }
                
                this.entity.analytics_data_values.push({
                    id: maxId + 1,
                    title: ''
                });
            },
            removeAnalyticsValue(index) {
                this.entity.analytics_data_values.splice(index, 1);
            },
            async setAnalyticsValue(index, value) {
                this.entity.analytics_data_values[index].title = value;
            },

            async create() {
                if (!this.entity.title) {
                    this.$root.$emit('showError', 'Укажите название сервиса.');
                    return;
                }
                if (!this.entity.code) {
                    this.$root.$emit('showError', 'Укажите код сервиса.');
                    return;
                }
                if (!this.entity.color) {
                    this.$root.$emit('showError', 'Укажите цвет сервиса.');
                    return;
                }
                if (!this.entity.gradient) {
                    this.$root.$emit('showError', 'Укажите градиент сервиса.');
                    return;
                }
                if (!this.selectedPicture) {
                    this.$root.$emit('showError', 'Выберите картинку сервиса.');
                    return;
                }

                try {
                    let formData = new FormData();

                    if (this.selectedLargePicture) {
                        formData.append('file', this.selectedLargePicture);
                        const largePictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.large_picture = largePictureName.data.filename;
                    }

                    formData = new FormData();
                    formData.append('file', this.selectedPicture);

                    const uploadPicture = await Vue.axios.post('/files/upload', formData);
                    this.entity.picture = uploadPicture.data.filename;

                    const newEntityType = await Vue.axios.post('/entities-type', this.entity);

                    this.$router.push({
                        path: '/settings/entities/' + newEntityType.data.id,
                    });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                } finally {
                    this.$store.dispatch('fetchSidebarData');
                }
            },

            goBack() {
                this.$router.push({ path: '/settings/entities/' });
            },
        },
    };
</script>
